'use strict';

function LoanApplicationStart() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._$classes = {
    nextBtn: '.js--next'
  };

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._$node = $(this.node);
    this._$nextBtn = this._$node.find(this._$classes.nextBtn);
    this._offerName = this._activeOffer.getOfferName();
    this._pushAnalytics();
    this._setupEventHandlers();
    this._removeProgressLoader();
  };

  this.destroy = function () {
    this._super();
  };

  this._pushAnalytics = function () {
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setupEventHandlers = function () {
    this._$nextBtn.on('click', this._onLoansApplicationNextStep.bind(this));
  };

  // perform action: create_loan_application
  // Required: product: 'liquid'
  this._onLoansApplicationNextStep = function (e) {
    e.preventDefault();
    this._$nextBtn.mogo().setDisabledLoadState();

    if (this._loanApplications.length > 0) {
      // Direct to correct step
      this._routeToStep();
    } else {
      this._$nextBtn.mogo().setDisabledLoadState();
      this.createLoanApplication(this._offerName, {
        success: this._onCreateLoanApplicationSuccess.bind(this),
        failure: this._onCreateLoanApplicationFail.bind(this)
      });
    }
  };

  this._onCreateLoanApplicationSuccess = function (loanApplication, data, response, request) {
    // soa_env.analytics, on create loan application, new applications only
    if (this._activeOffer.getOfferType() !== 'level_up') {
      var analyticsData = this.analytics.constructData('Liquid Digital Application Started');
      var analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);
      analyticsRequest.send();
    }

    this._routeToStep();
  };

  this._routeToStep = function () {
    // Direct to correct step
    _this._$nextBtn.mogo().setDisabledLoadState();
    var currentStep = _this._loanApplications[0].getCurrentStep();
    $('#LoanApplicationTray').mogo().goToLoanApplicationStep(currentStep);
    var traynav = $('#LoanApplicationTray .tray-navigation').mogo();
    traynav.setDisabled(0); // fix "Get Started" item always being enabled
    traynav.setEnabled(traynav.getSelectedIndex()); // fix next item being disabled when selected
  };

  this._onCreateLoanApplicationFail = function (data, response, request) {
    this._$nextBtn.mogo().removeLoadState();
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, { productLabel: 'Money' }, null, {
          retryRequest: true
        });
      }
    } else {
      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };
}